var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconSeverity(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 20,
    viewBox: "0 0 19 20",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#90A9C0",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.423 15.64v-5.442c0-3.524-2.743-6.391-6.115-6.391-3.372 0-6.115 2.867-6.115 6.39v5.443A1.79 1.79 0 0 0 2 17.325v1.906c0 .328.267.595.595.595H16.02a.595.595 0 0 0 .595-.595v-1.906c0-.777-.498-1.44-1.192-1.685ZM9.308 4.996c2.716 0 4.926 2.334 4.926 5.202v5.34H4.382v-5.34c0-2.868 2.21-5.202 4.926-5.202Zm6.117 13.64H3.191v-1.311c0-.33.267-.597.596-.597H14.83c.329 0 .596.267.596.597v1.311ZM8.713.04h1.19v2.662h-1.19zM4.925 2.035l.839 1.459-1.032.593-.839-1.46zM.676 4.955 2.61 6.27l-.669.984L.007 5.94zM.352 10.228H1.65v1.19H.352zM17.043 10.228h1.298v1.19h-1.298zM18.536 6.012l-1.865 1.246-.66-.99 1.865-1.245zM14.738 2.843l-.879 1.283-.982-.673.88-1.283z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.261 9.873h1.19v4.203h-1.19z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSeverity);
export default __webpack_public_path__ + "static/media/icon_severity.aced6a9b609656ed83edfe674e233a42.svg";
export { ForwardRef as ReactComponent };